var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.editType == 1 ? "新增" : "编辑",
        "close-on-click-modal": false,
        visible: _vm.innerVisible,
        width: "700px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "80px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "通知标题", prop: "bigHead" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.bigHead,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "bigHead", $$v)
                  },
                  expression: "ruleForm.bigHead",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "通知链接", prop: "link" } },
            [
              _c(
                "el-input",
                {
                  model: {
                    value: _vm.ruleForm.link,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "link", $$v)
                    },
                    expression: "ruleForm.link",
                  },
                },
                [_c("template", { slot: "prepend" }, [_vm._v("Http://")])],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            _vm._l(_vm.ruleForm.smallHead, function (smallHeadRow, rowIndex) {
              return _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      width: "100%",
                      "margin-bottom": "10px",
                    },
                  },
                  _vm._l(smallHeadRow, function (item, listIndex) {
                    return _c("div", { staticStyle: { width: "100%" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            width: "100%",
                          },
                        },
                        [
                          _c("div", { staticStyle: { width: "100%" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  flex: "1",
                                  "flex-direction": "row",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100px" },
                                  attrs: { placeholder: "标题" + item.label },
                                  model: {
                                    value: item.title,
                                    callback: function ($$v) {
                                      _vm.$set(item, "title", $$v)
                                    },
                                    expression: "item.title",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticStyle: { margin: "0 2px" },
                                  attrs: { placeholder: "请输入内容" },
                                  model: {
                                    value: item.value,
                                    callback: function ($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.editType == 1
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "row",
                                          "flex-wrap": "nowrap",
                                          "margin-right": "5px",
                                        },
                                      },
                                      [
                                        _c("div", [
                                          smallHeadRow.length == 1
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-circle-plus",
                                                staticStyle: {
                                                  color: "rgb(153, 153, 153)",
                                                  margin: "0 2px",
                                                  "font-size": "17px",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addSmallHead(
                                                      rowIndex,
                                                      listIndex
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c("i", {
                                            staticClass: "el-icon-remove",
                                            staticStyle: {
                                              color: "rgb(153, 153, 153)",
                                              margin: "0 2px",
                                              "font-size": "17px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteSmallHead(
                                                  rowIndex,
                                                  listIndex
                                                )
                                              },
                                            },
                                          }),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "zj-form-bottom",
              staticStyle: { "margin-top": "10px" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _vm.editType == 1
                ? _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addSmallHead(-1, -1)
                        },
                      },
                    },
                    [_vm._v("新增行")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }